import { IProjectActivityClustering } from '..//views/project/types/projectActivity';
import { statusColor } from '../utils/statusColor'
import { IActivityFilter } from '../views/project/types/activityFilters'
import { IProjectPhase } from '../views/project/types/project'
import { IProjectActivity, IProjectActivitySortColumn, IProjectActivitySorting } from '../views/project/types/projectActivity'
import { IDepartment } from '../views/settings/types/department'

export const _initialActivity: IProjectActivity = {
  id: '',
  name: '',
  phase: {} as IProjectPhase,
  department: {} as IDepartment,
  start_date: '',
  end_date: '',
  current_hours: 0,
  total_hours: 0,
  value: 0,
  percentage: '',
  status: 'upcoming',
  statusColor: (status: string) => statusColor(status),
  focused: false,
  remainingHours: '',
  remainingHoursPercentage: '',
  time_completion: 0,
  assigned_employees: [],
  labels: [],
  last_start_date: '',
  last_end_date: '',
}

export const _initialSort: IProjectActivitySorting = {
  clustering: 'phase',
  column: {} as IProjectActivitySortColumn
}

export const _activities: IProjectActivity[] = [
  {
    id: 1,
    name: 'Test Activity One',
    phase: { id: 1, name: 'Test Phase One', active: true, start_date: '', end_date: '', finished: false, color: '#2F61D5' },
    department: { id: 1, name: 'Test Department One', hourly_rate: '10' },
    start_date: null,
    end_date: null,
    current_hours: 12,
    total_hours: 120,
    value: 0,
    percentage: '',
    status: 'upcoming',
    statusColor: (status: string) => statusColor(status),
    focused: false,
    remainingHours: '',
    remainingHoursPercentage: '',
    time_completion: 0,
    budget: 0,
    expenditures: 0,
    forecast: 0,
    assigned_employees: [],
    labels: [],
    last_start_date: '',
    last_end_date: '',
  },
  {
    id: 2,
    name: 'Test Activity Two',
    phase: { id: 2, name: 'Test Phase Two', active: false, start_date: '', end_date: '', finished: true, color: '#FF7052' },
    department: { id: 2, name: 'Test Department Two', hourly_rate: '10' },
    start_date: null,
    end_date: null,
    current_hours: 12,
    total_hours: 120,
    value: 0,
    percentage: '',
    status: 'upcoming',
    statusColor: (status: string) => statusColor(status),
    focused: false,
    remainingHours: '',
    remainingHoursPercentage: '',
    time_completion: 0,
    budget: 0,
    expenditures: 0,
    forecast: 0,
    assigned_employees: [],
    labels: [],
    last_start_date: '',
    last_end_date: '',
  }
]

export const _activityFilter: IActivityFilter[] = [
  {
    name: 'Status',
    options: [
      { value: 'upcoming', name: 'Upcoming', selected: true },
      { value: 'completed', name: 'Completed', selected: false }
    ]
  }
]

export const _clusteredActivities: IProjectActivityClustering[] = [
  {
    activities: [
      {
        id: 1,
        name: 'Test Activity One',
        phase: { id: 1, name: 'Test Phase One', active: true, start_date: '', end_date: '', finished: false, color: '#2F61D5' },
        department: { id: 1, name: 'Test Department One', hourly_rate: '10' },
        start_date: null,
        end_date: null,
        current_hours: 12,
        total_hours: 120,
        value: 0,
        percentage: '',
        status: 'upcoming',
        statusColor: (status: string) => statusColor(status),
        focused: false,
        remainingHours: '',
        remainingHoursPercentage: '',
        time_completion: 0,
        budget: 0,
        expenditures: 0,
        forecast: 0,
        assigned_employees: [],
        labels: [],
        last_start_date: '',
        last_end_date: '',
      },
      {
        id: 2,
        name: 'Test Activity Same Phase',
        phase: { id: 1, name: 'Test Phase One', active: true, start_date: '', end_date: '', finished: false, color: '#2F61D5' },
        department: { id: 2, name: 'Test Department Two', hourly_rate: '10' },
        start_date: null,
        end_date: null,
        current_hours: 15,
        total_hours: 150,
        value: 0,
        percentage: '',
        status: 'completed',
        statusColor: (status: string) => statusColor(status),
        focused: false,
        remainingHours: '',
        remainingHoursPercentage: '',
        time_completion: 0,
        budget: 0,
        expenditures: 0,
        forecast: 0,
        assigned_employees: [],
        labels: [],
        last_start_date: '',
        last_end_date: '',
      }
    ],
    name: 'Test Phase One',
    phase: { id: 1, name: 'Test Phase One', active: true, start_date: '', end_date: '', finished: false, color: '#2F61D5' }
  }
]

export const _initialTimeTrackingInvolvedTasks = {
  id: '',
  name: '',
  offer_position: '',
  end_date: '',
  current_hours: 0,
  total_hours: 0,
}
